<template>
<div >
  <div class="row">
    <LoginHistory :value="value" class="col pr-0" />
    <Audit :value="value" class="col" />
  </div>
</div>
</template>

<script>
import LoginHistory from './components/LoginHistory'
import Audit from './components/Audit'
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    LoginHistory,
    Audit
  }
}
</script>

<style scoped>
.row {
  margin-right: -13px !important;
  margin-left: -13px !important;
}
</style>
